import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';

export const adminRoleGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	if (authService.hasAdminRole()) {
		return true;
	}
	authService.navigateAfterLogin();
	return false;
};
